import {SET_FORCE_PRINT} from "./actionTypes";

export function setForcePrint(forcePrint) {
  return {
    type: SET_FORCE_PRINT,
    forcePrint
  }
}